// src/services/authService.js
import api from '../utils/api'; // Assuming you have an API utility

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1/stag';

export const authService = {
  login: async (credentials) => {
    const response = await api.post(`${API_URL}/auth/login`, credentials);
    return response;
  },

  register: async (userData) => {
    const response = await api.post(`${API_URL}/auth/register`, userData);
    return response;
  },

  logout: async () => {
    // Optional: Call backend logout if needed
    // await api.post(`${API_URL}/auth/logout`);
  },

  verifyToken: async (token) => {
    const response = await api.get(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },

  forgotPassword: async (email) => {
    const response = await api.post(`${API_URL}/auth/forgot-password`, { email });
    return response;
  },

  resetPassword: async (token, newPassword) => {
    const response = await api.post(`${API_URL}/auth/reset-password`, {
      token,
      newPassword,
    });
    return response;
  },
};

export default authService;